import styled from 'styled-components';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

export const FltRecCategoryList = styled.ul`
  margin-bottom: 20px;
  padding-top: 4px;

  .item {
    margin-top: 8px;

    &:first-child {
      margin-top: 0;
    }
  }

  @media ${({ theme }) => theme.media.smMax} {
    margin-bottom: ${mixin.pxToVw('20')};
    padding-top: ${mixin.pxToVw('4')};

    .item {
      margin-top: ${mixin.pxToVw('8')};
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    .item {
      margin-top: 10px;
    }
  }
`;
